import { DEFAULT_LOCATIONS, COVENANTHEALTH, CHECKMARK } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 492ce60fc088b2d6c856438230f160052b08eb49',
  staging: 'Token b885541cd2e6620f5566e330cdbf2449c549d84a',
  prod: 'Token d7a44791d24b88fd0931a354ffe491d4436befd2',
};

const token = selectToken(apiTokens);

const covenantHealthConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'covenanthealth',

  API_TOKEN: token,
  EMBOLD_CLIENT: COVENANTHEALTH,

  // login
  SHOW_REGION_SELECTOR: false,
  NETWORKS: {},

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Andover },
  LOGIN_NETWORK_NAME: 'covenantHealthUserId',

  // content
  DISPLAY_NAME: 'Covenant Health',
  FORM_VARIANT: CHECKMARK,
  NO_WELCOME_LINK: false,
};

export default covenantHealthConfig;
